<template>
  <div class="row">
    <div class="col-md-8 col-sm-12">
      <Title class="col-12 mb-2" :page="page" />
      <BreadCrumb :page="page" class="ml-4" />
    </div>

    <div class="col-md-4 col-sm-12 text-right mt-4">
      <ActionButton
        class="btn btn-green outline-success"
        i="fas fa-arrow-circle-left"
        type="button"
        @click="$router.go(-1)"
      >
        Regresar
      </ActionButton>

      <ActionButton
        class="btn btn-green success"
        i="fas fa-save"
        type="button"
        @click="save()"
      >
        Guardar
      </ActionButton>
    </div>

    <div class="dropdown-divider mt-0 pb-2 w-100" />

    <div class="col-md-12">
      <div class="row-group w-100 ml-2">
        <div class="col-md-12 col-sm-12">
          <SectionTitle
            icon="fas fa-file-user"
            content="I. Información General del Estudiante"
            container-class="tag-badge-main-info mt-4 mb-4"
          />
        </div>
        <RowCardItem id="serviceInfo" :hide-icon="true" class="ml-2 mr-3">
          <div slot="header" class="row">
            <div class="d-flex align-items-start col-12 col-md-2 col-sm-6">
              <div class="icon-container ml-lg-n5 ml-md-n5 ml-sm-0">
                <em class="fas fa-address-book text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Nombre:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.name }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start col-12 col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-address-book text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">SIE:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.sie }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start col-12 col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-ballot-check text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Tipo de evaluación:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.evaluationType }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start col-12 col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-ballot-check text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Disciplina:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.disciplineName }}
                </span>
              </div>
            </div>
            <div class="d-flex align-items-start col-12 col-md-2 col-sm-6">
              <div class="icon-container">
                <em class="fas fa-ballot-check text-orange" />
              </div>
              <div class="d-flex flex-column">
                <span class="data-title">Fecha de referido:</span>
                <span class="data-content">
                  {{ ProvisionalRemedyRequest.applicationDate }}
                </span>
              </div>
            </div>
          </div>
        </RowCardItem>
      </div>
    </div>
    <div v-if="ProvisionalRemedyRequest.sie" class="row w-100">
      <div class="col-md-12">
        <remedy-request-form
          ref="_remedyRequestRef"
          :info="ProvisionalRemedyRequest"
        />
      </div>
    </div>
    <div class="col-12 text-right mt-4">
      <FixedBottomSaveButton :offset="200" @click="save" />
    </div>
  </div>
</template>

<script>
import Title from '@/components/common/page/Title';
import BreadCrumb from '@/components/common/page/BreadCrumb';
import { SectionTitle } from '@/components/pei/shared';
import ActionButton from '@/components/common/ActionButton';
import mixAlert from '@/mixin/alert.mixin';
import RemedyRequestForm from '@/components/common/RemedyRequest/Form';
import RowCardItem from '@/components/common/rowcard/RowCardItem';
import FixedBottomSaveButton from '@/components/common/FixedBottomSaveButton';

import moment from 'moment';
import 'moment/locale/es-do';
moment.locale('es-do');

export default {
  name: 'ProvisionalRemedyRequest',
  mixins: [mixAlert],
  components: {
    Title,
    BreadCrumb,
    SectionTitle,
    ActionButton,
    RemedyRequestForm,
    RowCardItem,
    FixedBottomSaveButton,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-circle',
        title: 'Solicitud de Evaluación',
        routes: [
          'Inicio',
          'Estudiante',
          'Manejo de Coordinación y evaluación',
          'Solicitud de Evaluación',
        ],
      },
      ProvisionalRemedyRequest: {
        name: null,
        sie: null,
        evaluationType: null,
        discipline: null,
        applicationDate: null,
        studentReferralId: null,
        disciplineTypeId: null,
        AcademicYearId: null,
      },
    };
  },
  methods: {
    save() {
      this.$refs._remedyRequestRef.save();
    },
  },
  async created() {
    const remedyInfo = this.$store.state.ProvisionalRemedyRequest;

    this.ProvisionalRemedyRequest = {
      name: remedyInfo.name,
      sie: remedyInfo.sie,
      ThrpyAdmissionId: null,
      ThrpyDisciplineTypeId: remedyInfo.thrpyDisciplineTypeId,
      ThrpyFrequencyTypeId: null,
      ThrpyModalityTypeId: null,
      ThrpyReferralDate: moment(
        remedyInfo.applicationDate,
        'DD/MMM/YYYY'
      ).toDate(),
      ThrpyTherapyDurationId: null,
      evaluationType: remedyInfo.evaluationType,
      academicYearId: remedyInfo.AcademicYearId,
      disciplineName: remedyInfo.discipline,
      duration: null,
      frequecy: null,
      modalityTypeName: null,
      applicationDate: remedyInfo.applicationDate,
      hasServiceDetails: false,
      isThrpy: remedyInfo.isThrpy,
      studentReferralId: remedyInfo.studentReferralId,
    };
  },
};
</script>

<style scoped lang="scss">
.main-content {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.top-radius {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.bottom-divider {
  border-bottom: 1px solid lightgray;
  border-bottom-width: thin;
}
.radius-5 {
  border-radius: 5px;
}
.fs-16 {
  font-size: 16px;
}
.row.w-100.font-weight-regular {
  font-weight: normal;
}

.pd {
  padding-top: 10px;
}

.icon-container {
  margin-top: 3px;
  margin-right: 12px;
  .far,
  .fas {
    font-size: 20px;
  }
}
.data-title {
  font-size: 16px;
}

@media only screen and (max-width: 768px) {
  ::v-deep .fixed-button-custom {
    left: 0px;
  }

  ::v-deep .tag-badge-main-info {
    width: 100%;
    .tag-badge-title-info {
      font-size: 0.8rem;
    }
  }
}
</style>
